import React from "react";
import {FullScreenLoadingContainer} from "./style";

export const FullScreenLoading = props => {
    return (
        <FullScreenLoadingContainer>
            {/*<LoadingFullScreenLoadingContainer size={props.size}>*/}
            <div className="dot-flashing" />
            {/*</LoadingFullScreenLoadingContainer>*/}
            {/*<div className="text">*/}
            {/*  درحال دریافت اطلاعات از سرور*/}
            {/*  <br />*/}
            {/*  لطفا چند لحظه منتظر بمانید.*/}
            {/*</div>*/}
        </FullScreenLoadingContainer>
    );
};
